import { isSpanishLanguage } from "utilities/getPreferredLanguage";

const PREFERENCE_CENTER_HOST_PROD = "https://www.newamericanfunding.com";
const PREFERENCE_CENTER_HOST_LOWER = "https://preprod.newamericanfunding.com";
const PRODUCTION_HUB_HOSTS = new Set(["nafhub.com", "www.nafhub.com"]);
const PROSPECT_ID_GUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isProductionHubHost(hostname?: string | null): boolean {
  const host = hostname?.trim().toLowerCase() ?? "";
  return PRODUCTION_HUB_HOSTS.has(host);
}

function getPreferenceCenterHost(hostname?: string | null): string {
  return isProductionHubHost(hostname)
    ? PREFERENCE_CENTER_HOST_PROD
    : PREFERENCE_CENTER_HOST_LOWER;
}

function resolveHostname(hostname?: string | null): string {
  return hostname ?? globalThis.location?.hostname ?? "";
}

export function buildPreferenceCenterUrl(
  prospectId?: string | null,
  preferredLanguage?: string | null,
  hostname?: string | null,
): string | null {
  const id = prospectId?.trim() ?? "";
  if (!PROSPECT_ID_GUID_PATTERN.test(id)) {
    return null;
  }

  const path = isSpanishLanguage(preferredLanguage)
    ? "/preference-center/es/"
    : "/preference-center/";

  return `${getPreferenceCenterHost(resolveHostname(hostname))}${path}?id=${encodeURIComponent(id)}`;
}
